(function(){
  // TODO: replace with your deployed Supabase Edge Function URL, e.g.
  // https://YOUR_PROJECT_REF.supabase.co/functions/v1/ai-tool-search
  var AST_SEARCH_ENDPOINT = 'https://tlqvenjoosdjrywsoebj.supabase.co/functions/v1/ai-tool-search';
  var AST_SUPABASE_ANON_KEY = 'sb_publishable_1rKVuR_HpY17z9dbF0kQlw_clSufNHa';

  var form = document.getElementById('astSearchForm');
  var input = document.getElementById('astSearchInput');
  var statusEl = document.getElementById('astSearchStatus');
  var captionEl = document.getElementById('astSearchCaption');
  var resultsEl = document.getElementById('astSearchResults');
  if (!form) return;

  var lastQuestion = '';

  function escapeHtml(str){
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  function domainFromUrl(url){
    try {
      var d = new URL(url).hostname.replace(/^www\./, '');
      return d;
    } catch(e){ return ''; }
  }

  function cardHtml(tool, isBest){
    var fav = tool.favicon ? '<img class="ast-search-card-fav" src="' + escapeHtml(tool.favicon) + '" alt="" loading="lazy">' : '';
    var badge = isBest ? '<span class="ast-search-badge">Best match</span>' : '';
    var target = tool.affiliate_url || tool.url;
    var domain = domainFromUrl(target);
    var headline = tool.headline || tool.title;
    return '<a href="' + escapeHtml(target) + '" class="ast-search-card' + (isBest ? ' is-best' : '') + '">' +
      '<span class="ast-search-card-info" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg></span>' +
      badge +
      '<div class="ast-search-card-site">' + fav +
        '<div class="ast-search-card-site-text"><span class="ast-search-card-name">' + escapeHtml(tool.title) + '</span>' +
        (domain ? '<span class="ast-search-card-domain">' + escapeHtml(domain) + '</span>' : '') + '</div>' +
      '</div>' +
      '<div class="ast-search-card-headline">' + escapeHtml(headline) + '</div>' +
      '<p class="ast-search-card-desc">' + escapeHtml(tool.reason || '') + '</p>' +
    '</a>';
  }

  function viewAllCardHtml(categoryUrl){
    return '<a href="' + escapeHtml(categoryUrl) + '" class="ast-search-card ast-search-card--viewall">' +
      '<div class="ast-search-viewall-inner">' +
        '<span class="ast-search-viewall-icon" aria-hidden="true">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>' +
        '</span>' +
        '<span class="ast-search-card-name">View all results</span>' +
        '<p class="ast-search-card-desc">See every tool in this category</p>' +
      '</div>' +
    '</a>';
  }

  function renderFlat(results, categoryUrl){
    captionEl.innerHTML = 'Best matched tools for: <span class="ast-search-caption-query">' + escapeHtml(lastQuestion) + '</span>';
    var html = '<div class="ast-search-grid">';
    results.forEach(function(tool, i){
      html += cardHtml(tool, i === 0);
    });
    if (categoryUrl) {
      html += viewAllCardHtml(categoryUrl);
    }
    html += '</div>';
    resultsEl.innerHTML = html;
  }

  function renderSteps(steps){
    captionEl.innerHTML = 'Best matched tools for: <span class="ast-search-caption-query">' + escapeHtml(lastQuestion) + '</span>';
    var html = '';
    steps.forEach(function(step, idx){
      html += '<div class="ast-search-step">' +
        '<div class="ast-search-step-head">' +
          '<span class="ast-search-step-num">' + (idx + 1) + '</span>' +
          '<span class="ast-search-step-title">' + escapeHtml(step.label) + '</span>' +
        '</div>' +
        '<div class="ast-search-grid">';
      (step.results || []).forEach(function(tool, i){
        html += cardHtml(tool, i === 0);
      });
      if (step.category_url) {
        html += viewAllCardHtml(step.category_url);
      }
      html += '</div></div>';
    });
    resultsEl.innerHTML = html;
  }

  var AST_TIP_MAP = {
    'image': ['free images', 'free stock images', 'create thumbnail images'],
    'images': ['free images', 'free stock images', 'create thumbnail images'],
    'photo': ['free stock photos', 'edit photos'],
    'photos': ['free stock photos', 'edit photos'],
    'video': ['free videos', 'free stock video', 'create a video'],
    'videos': ['free videos', 'free stock video', 'create a video'],
    'music': ['free music', 'royalty-free music', 'generate background music'],
    'logo': ['create a logo', 'generate a logo design'],
    'writing': ['improve my writing', 'write SEO blog posts'],
    'email': ['write marketing emails', 'automate email campaigns'],
    'seo': ['improve SEO for my blog', 'research SEO keywords'],
    'design': ['create social media graphics', 'design a logo'],
    'voice': ['generate AI voiceovers', 'convert text to speech'],
    'code': ['write and debug code', 'generate code snippets']
  };

  function buildTip(question){
    var words = question.trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (words.length > 2) return null;
    for (var i = 0; i < words.length; i++){
      if (AST_TIP_MAP[words[i]]) {
        return AST_TIP_MAP[words[i]];
      }
    }
    return null;
  }

  function renderEmpty(){
    captionEl.textContent = '';
    var examples = buildTip(lastQuestion);
    var tipHtml;
    if (examples) {
      tipHtml = '<p class="ast-search-tip">Tip: this works best as a full goal, not just a keyword. Try: ' +
        examples.map(function(ex){ return '<button type="button" class="ast-search-tip-chip">' + escapeHtml(ex) + '</button>'; }).join(' ') +
        '</p>';
    } else {
      tipHtml = '<p class="ast-search-tip">Tip: this works best as a full goal, not just a keyword — try describing what you want to do, e.g. "create thumbnail images" instead of "images".</p>';
    }
    resultsEl.innerHTML = '<div class="ast-search-empty">No strong matches found — try rephrasing your goal, or <a href="/collections/all">browse all tools</a>.' + tipHtml + '</div>' +
      '<div class="ast-search-retry"><button type="button" onclick="document.getElementById(\'astSearchInput\').focus()">Try a different goal</button></div>';

    var tipChips = resultsEl.querySelectorAll('.ast-search-tip-chip');
    tipChips.forEach(function(chip){
      chip.addEventListener('click', function(){
        var q = chip.textContent.trim();
        input.value = q;
        var url = new URL(window.location.href);
        url.searchParams.set('q', q);
        window.history.replaceState({}, '', url);
        runSearch(q);
      });
    });
  }

  function cacheKey(question){
    return 'ast_search_' + question.trim().toLowerCase();
  }

  function smoothScrollTo(targetY, duration){
    var startY = window.pageYOffset;
    var diff = targetY - startY;
    var startTime;
    function step(timestamp){
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var ease = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
      window.scrollTo(0, startY + diff * ease);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function scrollToTop(){
    var headline = document.querySelector('.ast-search-headline');
    if (!headline) return;
    setTimeout(function(){
      var y = headline.getBoundingClientRect().top + window.pageYOffset - 20;
      smoothScrollTo(y, 1100);
    }, 50);
  }

  function runSearch(question){
    lastQuestion = question;
    scrollToTop();
    var key = cacheKey(question);
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) {
        var data = JSON.parse(cached);
        statusEl.innerHTML = '';
        if (data.type === 'steps' && data.steps && data.steps.length) {
          renderSteps(data.steps);
        } else if (data.type === 'flat' && data.results && data.results.length) {
          renderFlat(data.results, data.category_url);
        } else {
          renderEmpty();
        }
        return;
      }
    } catch (e) {}

    var loadingMessages = [
      'Understanding what you need...',
      'Searching the catalog for matches...',
      'Comparing tools against your goal...',
      'Ranking the best options...',
      'Almost there...'
    ];
    var loadingIndex = 0;
    statusEl.innerHTML = '<span class="ast-search-pulse-dot"></span> ' + loadingMessages[0] + '<span class="ast-search-rolling-dots"><span></span><span></span><span></span></span>';
    var loadingInterval = setInterval(function(){
      loadingIndex++;
      if (loadingIndex >= loadingMessages.length) loadingIndex = loadingMessages.length - 1;
      statusEl.innerHTML = '<span class="ast-search-pulse-dot"></span> ' + loadingMessages[loadingIndex] + '<span class="ast-search-rolling-dots"><span></span><span></span><span></span></span>';
    }, 1700);
    resultsEl.innerHTML = '';
    captionEl.textContent = '';

    fetch(AST_SEARCH_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + AST_SUPABASE_ANON_KEY
      },
      body: JSON.stringify({ question: question })
    }).then(function(r){ return r.json(); }).then(function(data){
      clearInterval(loadingInterval);
      statusEl.innerHTML = '';
      try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (e) {}
      if (data.type === 'steps' && data.steps && data.steps.length) {
        renderSteps(data.steps);
      } else if (data.type === 'flat' && data.results && data.results.length) {
        renderFlat(data.results, data.category_url);
      } else {
        renderEmpty();
      }
    }).catch(function(){
      clearInterval(loadingInterval);
      statusEl.innerHTML = '';
      resultsEl.innerHTML = '<div class="ast-search-empty">Something went wrong — please try again.</div>';
    });
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var q = input.value.trim();
    if (!q) return;
    var url = new URL(window.location.href);
    url.searchParams.set('q', q);
    window.history.replaceState({}, '', url);
    runSearch(q);
  });

  var chips = document.querySelectorAll('.ast-search-chip');
  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      var q = chip.textContent.trim();
      input.value = q;
      var url = new URL(window.location.href);
      url.searchParams.set('q', q);
      window.history.replaceState({}, '', url);
      runSearch(q);
    });
  });

  var params = new URLSearchParams(window.location.search);
  var prefilled = params.get('q');
  if (prefilled) {
    input.value = prefilled;
    runSearch(prefilled);
  }
})();
